import { gql } from '@apollo/client';

export const getCategories = gql`
  query GetAllPostAdCategories {
    isMobile @client
    postAdCategories {
      category {
        id
        name
      }
      subtype
      ... on Subdata {
        subdata {
          title
          content {
            gid
            name
            href
            subtype
            content {
              gid
              name
              href
            }
          }
        }
      }
      ... on Subcat {
        subcat {
          gid
          name
          href
        }
      }
    }
  }
`;
